import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { 
  User, 
  Building
} from 'lucide-react';
import { ToastContainer, useToast } from '../../components/shared/Toast';
import {
  ProfileInformationTab,
  BusinessProfileTab
} from '../../components/vendor/profile';

const VendorProfile = () => {
  const { user, updateUser } = useAuth();
  const toast = useToast();
  const [activeTab, setActiveTab] = useState('profile');

  const tabs = [
    { id: 'profile', name: 'Profile', icon: User, fullName: 'Profile Information' },
    { id: 'business', name: 'Business', icon: Building, fullName: 'Business Profile' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="p-4 sm:p-6">
        <div className="mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Account Settings</h1>
          <p className="text-sm sm:text-base text-gray-600">Manage your account information and security settings.</p>
        </div>

        {/* Tab Navigation - Responsive */}
        <div className="border-b border-gray-200 mb-4 sm:mb-8 overflow-x-auto">
          <nav className="-mb-px flex space-x-2 sm:space-x-8 min-w-max sm:min-w-0">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center py-2 px-2 sm:px-1 border-b-2 font-medium text-xs sm:text-sm whitespace-nowrap transition-colors ${
                    activeTab === tab.id
                      ? 'border-primary-500 text-primary-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon className="w-4 h-4 sm:w-5 sm:h-5 mr-1 sm:mr-2 flex-shrink-0" />
                  <span className="hidden sm:inline">{tab.name}</span>
                  <span className="sm:hidden">{tab.name}</span>
                </button>
              );
            })}
          </nav>
        </div>

        {/* Tab Content - Responsive */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6 lg:p-8">
          {activeTab === 'profile' && <ProfileInformationTab user={user} updateUser={updateUser} readOnly={true} />}
          {activeTab === 'business' && <BusinessProfileTab user={user} updateUser={updateUser} readOnly={true} />}
        </div>
      </div>

      {/* Toast Container */}
      <ToastContainer 
        toasts={toast.toasts} 
        position="top-right"
        onRemove={toast.removeToast}
      />
    </div>
  );
};

export default VendorProfile;
